

































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
// interfaces
import { CcPageVm } from "@/interfaces/CcPageVm";
import { CustomizationVm } from "@/interfaces/CustomizationVm";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
  }
})
export default class EditModulePageDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop({ default: null }) modulePage!: CcPageVm | null;

  @globals.Action updateModulePage!: (modulePage: CcPageVm | null) => Promise<void>;
  @customization.Getter customizationSettings!: CustomizationVm;

  editModulePage: CcPageVm | null = null;
  formValid = false;
  isBusy = false;

  $refs!: {
    formElement: HTMLFormElement;
  };

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      await this.updateView();
      this.editModulePage = _.cloneDeep(this.modulePage);

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async updateView() {
  }

  async onSuggestTitle() {
    this.isBusy = true;
    await rest.url("contentManager/suggestAiPageDescription")
      .post(this.editModulePage)
      .then((response) => {
        if (!this.editModulePage || !response) return;
        if (response.length > 60) {
          response = response.substring(0, 57) + "...";
        }
        this.editModulePage.title = response;
      })
      .finally(() => {
        this.isBusy = false;
      });
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }

  async onSave() {
    if (!(await this.$refs.formElement.validate()))
      return;

    await this.updateModulePage(this.editModulePage);
    this.syncedShowDialog = false;
  }

  nameRules = [
    (v: string) => !!v || "Eingabe erforderlich",
    (v: string) => (v && v.length >= 1) || "Name zu kurz",
    (v: string) => (v && v.length <= 60) || "Name zu lang"
  ];
}
